//仅对userList处理

export default function roleFilter() {
  return function (roleList, flag, idList) {
    if (!roleList || !roleList.length) return '';
    let result = '';
    if (flag) {
      roleList.forEach((role) => {
        if (!idList.length || idList[0] == role.orgId)
          result += `[${role.roleName}]`;
      });
    } else {
      // 注意 避免把json.parse()放在循环里 避免数据多循环卡死
      let orgId = JSON.parse(localStorage.user_info).org.orgId;
      roleList.forEach((role) => {
        if (role.orgId == orgId) result += `[${role.roleName}]`;
      });
    }
    return result;
  };
}



// WEBPACK FOOTER //
// ./src/common/services/roleFilter.js